import {post} from '../utils/request'

// 获取订阅数
export function showGameBookCount() {
    return post('//gateway.r2game.com/?service=enplatactivity&api=showGamebook', {})
}

// 订阅
export function gameBook(data){
    return post('//gateway.r2game.com/?service=enplatactivity&api=gameBooking', data, {})
}


// 兑换礼包码
export function redeemCodeApi(data){
    return post('//gateway.r2game.com/?service=enplatCode&api=getActivityCodes', data, false)
}